// Customer reviews roll (sections/cc-reviews.liquid): slides at a steady px-per-second pace and never runs out.
// One set is measured in px (first card to the first card of the copy), more copies are added until the track
// covers the screen plus one set, then the track slides exactly one set per cycle. Pauses on hover.
// The CSS cc-roll animation is only the no-JS fallback; reduced motion keeps the static scroll row.
(() => {
  const speed = () => (innerWidth >= 900 ? 24 : 18); // px per second
  const init = (track) => {
    if (!track || track.dataset.ready || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const n = track.children.length / 2;
    if (!n) return;
    track.dataset.ready = '1';
    const roll = track.parentElement, copy = [...track.children].slice(n);
    let anim, hover = false, w = innerWidth;
    const run = () => {
      const set = track.children[n].offsetLeft - track.children[0].offsetLeft;
      if (set <= 0) return;
      while (track.offsetWidth < set + roll.clientWidth) copy.forEach((c) => track.appendChild(c.cloneNode(true)));
      const at = anim ? (anim.currentTime % anim.effect.getTiming().duration) / anim.effect.getTiming().duration : 0;
      if (anim) anim.cancel();
      const duration = (set / speed()) * 1000;
      anim = track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-set}px)` }], { duration, iterations: Infinity });
      anim.currentTime = at * duration;
      if (hover) anim.pause();
    };
    track.style.animation = 'none';
    run();
    roll.addEventListener('mouseenter', () => { hover = true; if (anim) anim.pause(); });
    roll.addEventListener('mouseleave', () => { hover = false; if (anim) anim.play(); });
    let t;
    addEventListener('resize', () => {
      if (innerWidth === w) return;
      w = innerWidth;
      clearTimeout(t);
      t = setTimeout(run, 150);
    });
  };
  const boot = () => document.querySelectorAll('.ccr .roll-track').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
